var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/uk/phone_number/index.js
 ** module id = 1153
 ** module chunks = 0
 **/